import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import NarrativeScreen from '../components/narrative/NarrativeScreen'

const TravelNarrative = () => {
    const gameState = useSelector(state => state.game)
    return gameState.narrative ? <NarrativeScreen /> : <Redirect to='/dashboard' />
}

export default TravelNarrative